export const workExperienceData = [
  {
    companyName: "Wlc Technologies",
    role: "React JS Developer",
    duration: "MAY 2021 - PRESENT",
    information: [
      "Turned UI/UX designs into prototypes, creating interactions from designs, writing reusable components, śmodules and maintainability of the code.",
      "Written maintainable code following coding standards and best practices.",
      "Worked closely with design, product management, and development teams to create elegant, reusable, responsive and interactive interface across multiple devices using tools like Figma, Adobe XD",
      "Implemented UI development principles to ensure that the product client-side serves at scale.",
      "Reviewed and optimized app usage by monitoring key metrics and rectifying the issues proactively",
    ],
  },
  {
    companyName: "Sparks Foundation",
    role: "ReactJs Developer Intern",
    duration: "NOV 2020 - APR 2021",
    information: [
      "Collaborated with colleagues on the creation of a new ideas in order to increase overall efficiency and transparency of web sites using React JS.",
      "Worked with Restfull Api Integration.",
      "Designed and developed an website according to Figma and Abobe ",
      "Developed Software components in ReactJS, Redux, css , Tailwind Css and Typescript.",
    ],
  },
];

export const skillsData = [
  {
    imageLink:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSj7U3XlVWRN6QwJtVDdBmCGqJDxEsBipL_w&usqp=CAU",
  },
  {
    imageLink:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQntgDWhCNA0GmplBCGSyDq01DeaOirjcF1mQ&usqp=CAU",
  },
  {
    imageLink:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnSyRzfMkifZx2RY0aRbmogzELQiFhFSAw2A&usqp=CAU",
  },
  {
    imageLink:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQvZN_yuppHVJPM4IlZEt0BUggHELpev-OrOg&usqp=CAU",
  },
  {
    imageLink:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQk8JHW5qttMHo5Lf0SYXsOHriPCpvJc3McIg&usqp=CAU",
  },
  {
    imageLink:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSdgVlOeuMHzszMHEdDV8qG49Rtx6vg-o0n2Q&usqp=CAU",
  },
  {
    imageLink:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9L5GIawim9buDyWHonhIOxbPtt12nla1lgQ&usqp=CAU",
  },
];

export const projectsData = [
  {
    projectImage:
      "https://www.logo.wine/a/logo/Reddit/Reddit-Vertical-Color-Logo.wine.svg",
    projectName: "Reddit Clone",
    projectDesc:
      "Build an Responsive Reddit Clone using Next JS and Superbase || This build is an social media app with nextjs auth and tailwind css with upvote comment and posting functionality",
    githubLink: "https://github.com/Bhupesh1x/redit-clone",
    liveLink: "https://redit-clone.vercel.app",
  },
  {
    projectImage: "https://links.papareact.com/f90",
    projectName: "Amazon Clone",
    projectDesc:
      "Build an Responsive Amazon Clone using React JS and Firebase || This build is an eccomerce app with redux as a state management library || User can sign in and use the functionality like add product to checkout",
    githubLink: "https://github.com/Bhupesh1x/amazon2.0",
    liveLink: "https://new-amazon-clone.netlify.app/",
  },
  {
    projectImage: "https://links.papareact.com/qd3",
    projectName: "Airbnb Clone",
    projectDesc:
      "Build an Responsive Airbnb Clone using Next JS and Tailwind css || This build is an full Airbnb clone with search and map functionality as well",
    githubLink: "https://github.com/Bhupesh1x/airbnb-new",
    liveLink: "https://airbnb-new.vercel.app/",
  },
  {
    projectImage:
      "https://rawn-docs.vercel.app/_next/image?url=%2Fapp-logo.png&w=1200&q=75",
    projectName: "Google Docs Clone",
    projectDesc:
      "Google docs clone using Next js React js Firebase Firestore Realtime DB Material UI (For Icons) Tailwind css Next Auth Rich text editor Google Authentication.",
    githubLink: "https://github.com/Bhupesh1x/google-docs",
    liveLink: "https://rawn-docs.vercel.app/login",
  },
  {
    projectImage:
      "https://cdn.icon-icons.com/icons2/2699/PNG/512/instagram_logo_icon_170643.png",
    projectName: "Instagram  Clone",
    projectDesc:
      "Build a Responsive Instagram Clone with Next JS React JS, tailwind Css and Firebase. || User can post like or comment after google sign in",
    githubLink: "https://github.com/Bhupesh1x/insta-2-clone",
    liveLink: "https://instagram-clone.vercel.app/",
  },
  {
    projectImage:
      "https://lh3.googleusercontent.com/g6WWfSMs3V0w2hhsaoc9myxQXmfO3IcRPwIsSo7nUJkNDHFb2JT4bffBiNH50_seojxYfC3AfBz8xNHd5k7tqXVsjRVvHGfJfAPx-zz8Lk7EQ0cPuA=rwu-v1-w1400",
    projectName: "Video Chat Clone",
    projectDesc:
      "Build an Video chat app with React. Firebase for Hosting, Google athentication(Full Log-In) and real time video chat for users.",
    githubLink: "https://github.com/Bhupesh1x/video-call-app",
    liveLink: "https://video-chat-app-d47b8.web.app/",
  },
  {
    projectImage:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgBm_jkdvW3QaaWsA8i1nHzDfOThkrg3mQSw&usqp=CAU",
    projectName: "Netflix  Clone",
    projectDesc:
      "Build an Netflix clone using React JavaScript . || This Website has a Api call using axios from The movie database(TMDB).and added icons using Material UI. || it is a single page application with sliding menus that communicates with the API",
    githubLink: "https://github.com/Bhupesh1x/netflix-clone",
    liveLink: "https://netflix-clone1809.netlify.app/",
  },
  {
    projectImage:
      "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
    projectName: "Whatsapp Clone",
    projectDesc:
      "Build an Whatsapp clone with React. Firebase for Hosting, Google athentication(Full Log-In) and real time Database.",
    githubLink: "https://github.com/Bhupesh1x/whatsapp-clone",
    liveLink: "https://whatsapp-clone-df343b.netlify.app/",
  },
];
